import React, {useState, useEffect, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectUserName } from "../features/auth/authSlice";
import "./Home.css";
import { Container, Row, Col } from "./imports";
import { Nav, Navbar } from "./imports";
import HomeDash from "./dashboard/HomeDash";
import EmailEditor from "./design/EmailEditor"; 
import ImageGallery from "./images/ImageGallery";
import Newsletter from "./newsletter/newsletter";
import ActivitySummary from "./summary/ActivitySummary";
import UploadJSONTemplateModal from "./components/JsonUpload";
import ImportHTMLEmailModal from "./components/htmlUpload";
import Advanced from "./advanced/advanced";
import Emails from "./emails/emails";
import Scheduling from "./scheduling/scheduling";

import { useChamaileonTokenMutation, useAddEmailMutation, useImportHTMLemailMutation } from '../app/api';
import chamaileonSDK from "@chamaileon-sdk/plugins";

function Home() {

    const dispatch = useDispatch();
    const username = useSelector(selectUserName);
    const [viewPage, setViewPage] = useState('dashboard');
    
    // trigger child component to trigger function by watching value of useState var
    const [triggerChild, setTriggerChild] = useState(0);

    const [addEmail] = useAddEmailMutation();
    const [showJSONUploadModal, s_showJSONUploadModal] = useState(false);
    const handleJSONUploadModal_Submit = async (json) => {
      const res = await addEmail({json_body: JSON.stringify(json), title: json.title}).unwrap();
      console.log('email added res:', res);
      // trigger child component to trigger refresh of emails 
      setTriggerChild(1);
      // reset value
      setTimeout(() => { setTriggerChild(0) }, 100);
    }

    const [importHTML] = useImportHTMLemailMutation();
    const [showImportHTMLModal, s_showImportHTMLModal] = useState(false);
    const handleImportHTMLModal_Submit = async (html, callback) => {
      const res = await importHTML({html: html}).unwrap();
      if(res && res.result && res.result.success){
        const d = res.result;
        try {
          const res2 = await addEmail({json_body: JSON.stringify(d.document), title: d.document.title}).unwrap();
          console.log('email added res2:', res2);
        } catch (e) {
          alert("There was an error importing your html template. Please try again or contact an admin.");
        }
        callback();
        // trigger child component to trigger refresh of emails
        setTriggerChild(1);
        // reset value
        setTimeout(() => { setTriggerChild(0) }, 100);
      } else {
        alert("There was an error importing your html template. Please try again or contact an admin.");
      }
    }

    // check local storage for chamailleon access token, valid for 24hours
    const lstoken = localStorage.getItem('chamaileon_access_token') ?? JSON.stringify({token:'notfound',exp:''});
    const [getChamToken] = useChamaileonTokenMutation();
    // set plugins to load chamaileon
    const [chamaileonPlugins, setChamaileonPlugins] = useState(null);
    const chamInitialized = useRef(false);
    const setTokenTime = () => {
        // Create a timestamp 12 hours in the future
        const futureTime = new Date();
        futureTime.setHours(futureTime.getHours() + 12);
        return futureTime;
    }
    const isTokenExpired = (t) => {
        const now = new Date();
        const exp = new Date(t);
        return exp <= now;
    }
    const setNewToken = () => {
        getChamToken()
        .unwrap()
        .then(response => {
            if(response.result){
                let tokenobj = {
                    token: response.result,
                    exp: setTokenTime()
                }
                localStorage.setItem('chamaileon_access_token', JSON.stringify(tokenobj));
                // console.log('new token gotten and set: ', tokenobj);
                initChamaileonSDK();
            } else {
                // console.error('Response from local API was unexpected, see network logs');
                alert('Response from local API was unexpected, see network logs and contact admin...'); 
            }
        }).catch(error => {
            if(error.status == 401 && error.data.detail.toLowerCase() == 'google sso token has expired'){
              if(chamaileonPlugins){chamaileonPlugins.destroy()}
              dispatch(logout())
            } else {
              alert('error retrieving Chamaileon API token, see logs or contact admin...');
            }
            
        });
    }
    // run token logic once
    useEffect(() => {
        const tokenData = JSON.parse(lstoken);
        // no token found in localstorage
        if(tokenData.token == 'notfound'){
            console.log('local storage chamaileon token not found, attempting to get a new one');
            setNewToken();
        // token found in local storage
        } else {    
            console.log('local storage chamaileon token found!');
            // check if expired (expiration date set 12 hours in advance, Chamailleon api describes tokens being viable for 24 hours)
            if(isTokenExpired(tokenData.exp)){
                // get new token
                console.log('local storage chamaileon expired, getting new token...');
                setNewToken();
            } else {
              initChamaileonSDK();
            }
        }
    }, []);

    const initChamaileonSDK = async () => {
        const accessToken = JSON.parse(localStorage.getItem('chamaileon_access_token')).token;  
        try {
            if(!chamInitialized.current){
              const whitelabelConfig = {
                  locale: 'en',
                  urls: {},
                  colors: {
                      'primary': '#2D3291',
                      'secondary': '#009f4a',
                      'red': '#ff5546',
                      'darkBlue': '#2d3291',
                      'darkGreen': '#00af6e',
                      'lightGreen': '#50d791',
                      'weirdGreen': '#50d791',
                      'pink': '#ff91a0',
                      'yellow': '#ffd23c',
                  }
              };
              const c = await chamaileonSDK({
                  accessToken,
                  ...whitelabelConfig,
              });
              setChamaileonPlugins(c);
              chamInitialized.current = true;
            }
        } catch(e) {
            console.error('SDK initialization error:', e);
        }
    };

    
  return (
    <div className="d-flex flex-column vh-100">

      <Navbar bg="dark" variant="dark" expand="lg">
        <Container fluid >
          <Navbar.Brand href="#home">Emails and Newsletters</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
            <Nav className="">
              <Nav.Link href="#home">{username}</Nav.Link>
              <Nav.Link href="#about" onClick={() => {if(chamaileonPlugins){chamaileonPlugins.destroy()} dispatch(logout())}}>logout</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container fluid className="flex-grow-1">
        <Row className="h-100">
          <Col md={3} className="bg-light p-3 menu-bar">
            <Nav className="flex-column">
              <Nav.Link href="" onClick={()=>{setViewPage('home')}}>
                <img src='../images/dash.png' style={{marginRight: '8px', width: '30px', height: '30px'}} alt="Dashboard" />
                Dashboard
              </Nav.Link>
              <Nav.Link href="" onClick={()=>{setViewPage('scheduling')}}>
                <img src='../images/schedule.png' style={{marginRight: '8px', width: '30px', height: '30px'}} alt="Email Scheduling" />
                Email Scheduling 
              </Nav.Link>
              <Nav.Link href="" onClick={()=>{setViewPage('design')}}>
                <img src='../images/design.png' style={{marginRight: '8px', width: '30px', height: '30px'}} alt="Design Emails" />
                Design Emails
              </Nav.Link>
              <Nav.Link href="" onClick={()=>{setViewPage('images')}}>
                <img src='../images/images.png' style={{marginRight: '8px', width: '30px', height: '30px'}} alt="Manage Images" />
                Manage Images
              </Nav.Link>
              <Nav.Link href="" onClick={()=>{ s_showJSONUploadModal(true); }}>
                <img src='../images/json.png' style={{marginRight: '8px', width: '30px', height: '30px'}} alt="Upload JSON Email Template" />
                Upload JSON
              </Nav.Link>
              <Nav.Link href="" onClick={()=>{ s_showImportHTMLModal(true); }}>
                <img src='../images/html.png' style={{marginRight: '8px', width: '30px', height: '30px'}} alt="Import HTML Email Template" />
                Import HTML
              </Nav.Link>
              <Nav.Link href="" onClick={()=>{setViewPage('advanced')}}>
                <img src='../images/advanced.png' style={{marginRight: '8px', width: '30px', height: '30px'}} alt="Advanced" />
                Advanced
              </Nav.Link>
              {/* <Nav.Link href="" onClick={()=>{setViewPage('summary')}}>Summary</Nav.Link> */}
              {/* <Nav.Link href="" onClick={()=>{setViewPage('newsletter')}}>Newsletters</Nav.Link> */}
              {/* <Nav.Link href="" onClick={()=>{setViewPage('emails')}}>Emails</Nav.Link> */}
            </Nav>
          </Col>
          <Col md={9} className="p-3">
            {
              viewPage == 'home' ? <HomeDash/> : 
              viewPage == 'images' ?  <ImageGallery/> :
              viewPage == 'design' ? <EmailEditor plugins={chamaileonPlugins} triggerChild={triggerChild}/> :
              viewPage == 'summary' ? <ActivitySummary/> : 
              viewPage == 'newsletter' ? <Newsletter/> : 
              viewPage == 'emails' ? <Emails/> : 
              viewPage == 'scheduling' ? <Scheduling/> : 
              viewPage == 'advanced' ? <Advanced/> :
              <HomeDash/>
            }
          </Col>
        </Row>
      </Container>

      <UploadJSONTemplateModal
        show={showJSONUploadModal}
        onHide={() => s_showJSONUploadModal(false)}
        onSubmit={handleJSONUploadModal_Submit}
      />

      <ImportHTMLEmailModal
        show={showImportHTMLModal}
        onHide={() => s_showImportHTMLModal(false)}
        onSubmit={handleImportHTMLModal_Submit}
      />

      <footer className="bg-dark text-light text-center py-3">
        <Container>
          <p>&copy; {new Date().getFullYear()} FFN. All rights reserved.</p>
        </Container>
      </footer>
    </div>
  );
}

export default Home;